import * as Sentry from '@sentry/react'
import { delay, put, takeLatest, throttle } from 'redux-saga/effects';
import { addNotification } from '../actions/notification';
import { NOTIFICATION_STATUS_ERROR } from '../types/Notification';
import { InvalidRequestWithMessageError, NotFoundRequestError } from '../util/error';
import { Action } from 'redux-saga';

export function* failureSaga(): Generator<any, void, unknown> {
  yield takeLatest((action: Action) => (/.*_FAILURE$/g).test(action.type), handleFailure)
}

export function* handleFailure(action: any): Generator<any, void, unknown> {
  const err = action.err !== undefined ? action.err : action.error

  if (err instanceof NotFoundRequestError) {
    console.warn('[404]', err)
    return
  }

  // Un conflit métier (400 accompagné d'un message dédié) est un refus attendu
  // du serveur, pas un incident : on le notifie à l'utilisateur mais on ne le
  // remonte pas à Sentry, où il ne ferait que du bruit. Le back applique la
  // même règle (logger.Warn plutôt que sentry.CaptureException).
  const isBusinessError = err instanceof InvalidRequestWithMessageError

  let eventId: string | undefined

  if (isBusinessError) {
    console.warn('[400]', err)
  } else {
    console.error(err)
    eventId = Sentry.captureException(err)
  }

  // Debounce failure notifications by 500ms
  // If multiples errors come at the same time, takeLatest() will cancel currently running sagas and
  // use only the latest
  yield delay(500)

  const message = typeof err?.getUserMessage === 'function' ? err?.getUserMessage() : `Une erreur inconnue est survenue ! (ID: ${eventId})`

  yield put(addNotification({ message, status: NOTIFICATION_STATUS_ERROR }));
}
